module.exports = __webpack_public_path__ + "static/link-logo-white-d403acdb4bb891883c03d5a34b739dd6.png";